export enum ForYouFloorChoiceType {
    GROUND = 1,
    LOW = 2,
    HIGH = 3,
    TOP = 4
}
export enum ForYouFloorChoiceType {
    GROUND = 1,
    LOW = 2,
    HIGH = 3,
    TOP = 4
}
